import { useCallback, useState } from 'react'

export default (initValue, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(initValue)
  const [timeout, setTime] = useState()

  const debouncer = useCallback(
    (val) => {
      if (timeout) {
        clearTimeout(timeout)
      }

      const handler = setTimeout(() => {
        setDebouncedValue(val)
        setTime(null)
      }, delay)
      setTime(handler)
    },
    [delay, timeout]
  )

  return { debouncer, debouncedValue }
}
